import { Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";

import ResultsTable from "../../../components/shared/Search/ResultsTable";
import { type ISearchResult } from "../../../pages/SearchPage/SearchPage.types";

interface Props {
  data: ISearchResult[] | undefined;
  onClose: () => void;
  title: string;
  isNormalEntries?: boolean;
  isMedical?: boolean;
}
const EntriesModal = ({
  data,
  onClose,
  title,
  isMedical,
  isNormalEntries,
}: Props) => {
  const [opened, { open, close }] = useDisclosure();

  useEffect(() => {
    if (data) open();
  }, [data, open]);

  const handleClose = () => {
    onClose();
    close();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title={title} size="xl">
      {data && data.length > 0 ? (
        <ResultsTable
          data={data}
          isNormalEntries={isNormalEntries}
          isMedical={isMedical}
          additionalOnNavigation={handleClose}
        />
      ) : (
        <Text style={{ textAlign: "center" }}>No history data found!</Text>
      )}
    </Modal>
  );
};
export default EntriesModal;
